module.exports = __webpack_public_path__ + "static/contact_centre-4d9f28516f4a886b011b2af441eb77dd.svg";